import styled from 'styled-components';
import { CustomRating } from './CustomRating';
import { RatingSizeDefinition } from './types/RatingSize';

export const RatingWithGap = styled(CustomRating)<{
	$sizeDefinition: RatingSizeDefinition;
}>`
	gap: ${props => props.$sizeDefinition.gap}px;
`;
